import styled from 'styled-components';

export const NumbersContainer = styled.div<{ isIcon: boolean }>`
  display: flex;
  flex-direction: column;
  margin-top: 36px;

  & > div:last-child {
    align-self: flex-end;

    .ant-btn {
      padding: 0;
    }

    margin-right: ${({ isIcon }) => (isIcon ? '35px' : 0)};
  }
`;

export const DeleteContainer = styled.div<{ isIcon: boolean }>`
  display: flex;

  .ant-form-item {
    width: 100%;
  }

  ${({ isIcon }) =>
    isIcon &&
    `
    & > div:last-child {
        align-self: flex-start;
        margin-top: 33px;
        margin-left: 12px;
        cursor: pointer;
    }
  `}
`;
